import { Tabs } from '@material-ui/core'
import styled, { css } from 'styled-components'

export const SIDEBAR_WIDTH = '280px'

export const sidebarStyle = css`
	width: ${SIDEBAR_WIDTH};

	.MuiDrawer-paper {
		padding-top: 15px;
		width: ${SIDEBAR_WIDTH};
		background-color: ${({ theme }) => theme.palette.background.default};

		.MuiList-root {
			.MuiListItem-root {
				font-style: normal;
				font-weight: 500;
				font-size: 14px;
				line-height: 18px;
				border-radius: 8px;
				letter-spacing: 0.2px;
				color: ${({ theme }) => theme.palette.content.dark};
				opacity: 1;

				.MuiListItemIcon-root {
					color: ${({ theme }) => theme.palette.content.dark};

					svg {
						fill: ${({ theme }) => theme.palette.text.disabled};
					}
				}

				&.Mui-selected {
					color: ${({ theme }) => theme.palette.content.veryLight};
					background: ${({ theme }) => theme.palette.secondary.sub};
					border-radius: 8px;

					svg {
						fill: ${({ theme }) => theme.palette.content.veryLight};
					}
				}
			}
		}
	}
`
export const mainContentStyle = css`
	width: 100%;
	margin-top: 90px;

	${({ theme }) => theme.breakpoints.down('sm')} {
		margin-bottom: 60px;
	}
`

export const mainWithoutMenuContentStyle = css`
	width: 100%;
	margin-top: ${(props) => (props.top ? `${props?.top}` : '90px')};

	${({ theme }) => theme.breakpoints.down('sm')} {
		margin-bottom: 0px;
		margin-top: 100px !important;
	}
`

export const mainContentChildrenStyle = css`
	min-height: calc(100vh - 165px);
`

export const mainContentJobDetailStyle = css`
	width: 100%;

	height: calc(100vh - 65px);
	overflow: hidden;

	> div {
		height: 100vh;
	}

	${({ theme }) => theme.breakpoints.up('md')} {
		padding-left: ${SIDEBAR_WIDTH};
	}

	${({ theme }) => theme.breakpoints.down('sm')} {
		margin-bottom: 70px;
		padding-bottom: 85px;
		height: calc(100vh - 120px);
	}
`

export const profileToggleStyle = css`
	position: absolute;
	top: 35px;
	left: ${({ theme }) => theme.spacing(2)}px;
	padding: 0;
	svg {
		g {
			rect {
				fill: ${({ theme }) => theme.colors.primary.main};
			}
		}
	}
`

export const drawerTopStyle = css`
	padding: 32px 16px;
	margin: 0;
	background-color: ${({ theme }) => theme.palette.secondary.light};

	.full-name {
		font-size: 15px;
		font-weight: 900;
		font-stretch: normal;
		font-style: normal;
		color: ${({ theme }) => theme.palette.text.secondary};
	}
`

export const closeBtnWrapperStyle = css`
	.MuiSvgIcon-root {
		fill: white;
	}
`

export const drawerBottomStyle = css`
	.MuiSvgIcon-root {
		fill: ${({ theme }) => theme.palette.text.primary};
	}

	.MuiListItemText-primary {
		font-size: 15px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		color: ${({ theme }) => theme.palette.text.primary};
	}
`

export const bottomAppBarStyle = css`
	position: fixed;
	top: auto;
	bottom: 0;
	width: 100%;

	.MuiBottomNavigation-root {
		height: 60px !important;
		background-color: ${({ theme }) => theme.palette.background.default};
		.MuiBottomNavigationAction-root {
			color: ${({ theme }) => theme.palette.text.disabled};
			opacity: 1;

			svg {
				fill: ${({ theme }) => theme.palette.text.disabled};
			}

			&.Mui-selected {
				color: ${({ theme }) => theme.palette.background.element.footerSideBar};

				.MuiSvgIcon-root {
					svg {
						fill: ${({ theme }) => theme.palette.text.primary};
					}
				}
			}
		}
	}

	.MuiBottomNavigationAction-label {
		padding-top: 3px;
		font-size: 11px;

		&.Mui-selected {
			border-bottom: 1px solid ${({ theme }) => theme.palette.primary.contrastText};
		}
	}
`

export const socialWrapperStyle = css`
	display: flex;
	gap: 10px;
	padding-left: 5px;
	.MuiListItem-button {
		background: white;
		border-radius: 50px;
		width: 44px;
		height: 44px;
		padding: 0 10px 0 0 !important;
		&:hover {
			text-decoration: none;
			opacity: 0.8;
		}
	}
	.MuiListItemIcon-root {
		padding-left: 12px;
		padding-top: 3px;
	}
`

export const menuItemStyle = css`
  &.MuiListItem-root {
    margin: 13px 0;
  }

  &.MuiBottomNavigationAction-root {
    opacity: 0.5;
  }

  .MuiListItemIcon-root {
    min-width: 40px;
  }

  .MuiListItemText-root {
    .MuiTypography-root {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.2px;
      color: ${({ theme }) => theme.palette.content.dark};
    }
  }

  &.MuiListItem-root.Mui-selected {
    .MuiListItemText-root {
      &.mobile-responsive {
        .MuiTypography-root {
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 18px;
          letter-spacing: 0.2px;
          color: ${({ theme }) => theme.palette.content.veryLight};
            //color: ${({ theme }) => theme.palette.background.element.light};
        }
      }

      .MuiTypography-root {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.2px;

        color: ${({ theme }) => theme.palette.content.veryLight};
      }
    }

    .MuiListItemIcon-root {
      &.mobile-responsive {
        color: ${({ theme }) => theme.palette.primary.main};
      !important;
      }

      color: ${({ theme }) => theme.palette.content.veryLight} !important;
    }
  }
`

export const menuDisabledItemStyle = css`
	&.MuiListItem-root {
		opacity: 0.24;
		margin: 13px 0;
	}

	&.MuiBottomNavigationAction-root {
		opacity: 0.24;
	}
`

export const containerStyle = css`
	display: flex;
	flex-direction: column;
	background: ${({ theme }) => theme.palette.content.veryLight};
	min-height: 100vh;

	.header-bar {
		background: #ffffff;
		border-bottom: 1px solid #e6e6e6;
		height: 90px;
		.MuiBottomNavigation-root {
			height: 87px;
		}
		.MuiBottomNavigationAction-root {
			opacity: 1;
		}
		.MuiBottomNavigationAction-root.Mui-selected {
			border-bottom: 3px solid #00aae5;
		}
		.layout-nav {
			display: flex;
			padding-right: 28px;
		}
		.layout-nav.fullWidth {
			width: 100%;
		}
	}

	.app-banner {
		background-color: white;
	}
`

export const leftMenuHeader = css`
	font-family: Avenir;
	font-size: 20px;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.35;
	letter-spacing: normal;
	text-align: left;
	color: #ffffff;
`

export const linkStyle = css`
	text-decoration: none;
	color: ${({ theme }) => theme.colors.hyperlink.medium};
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
`

export const pageTitleStyle = css`
	text-transform: uppercase;
	font-style: normal;
	font-weight: 700;
	font-size: 18px;
	line-height: 24px;
	color: ${({ theme }) => theme.colors.primary.main};
`

export const emptyDataStyle = css`
	background-color: ${({ theme }) => theme.palette.background.light};
	border-radius: 16px;
	text-align: center;

	.nodata-container {
		width: 200px;
		height: 150px;
		margin: auto;
	}

	svg {
		width: 350px;
		height: 350px;
	}

	.text-title {
		font-style: normal;
		font-weight: 700;
		font-size: 16px;
		line-height: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		letter-spacing: 0.1px;
		color: ${({ theme }) => theme.colors.primary.main};
		margin-top: 20px;
	}

	.text-info {
		font-size: 16px;
		font-style: normal;
		font-weight: 700;
		line-height: 24px; /* 150% */
		letter-spacing: 0.32px;
		align-items: center;
		text-align: center;
		padding: 39px 0px 47px 0px;
		margin-top: 30px;
		color: ${({ theme }) => theme.palette.content.dark};
	}

	.text-info:has(+ .sub-text) {
		padding-bottom: 0;
	}
	.sub-text {
		${({ theme }) => theme.typography.p1};
		color: ${({ theme }) => theme.palette.content.dark};
		font-weight: 500;
	}
`

export const submitStyle = css`
	color: #2854aa;
	border: 1px solid #2854aa;
	border-radius: 2px;
	padding: 0 4px;
`

export const loadMoreStyle = css`
	margin-top: 8px;
`
export const hiddenStyle = css`
	display: none;
`

export const submitButtonStyle = css`
	background: ${({ theme }) => theme.colors.primary.main};
	border: 1px solid ${({ theme }) => theme.colors.background.element.dark};
	border-radius: 36px;
	font-style: normal;
	font-weight: 600;
	font-size: 15px;
	line-height: 20px;
	color: ${({ theme }) => theme.colors.background.app.light};
	&:hover {
		color: ${({ theme }) => theme.colors.primary.main};
		border: 2px solid ${({ theme }) => theme.colors.primary.main};
		background: ${({ theme }) => theme.palette.background.app.light};
	}
`

export const sidebarMobileStyle = css`
	.MuiDrawer-paper {
		min-width: 220px;
		padding-top: 60px;
		background-color: ${({ theme }) => theme.colors.secondary.main};
	}

	.MuiListItemIcon-root {
		color: ${({ theme }) => theme.palette.background.app.light};
		min-width: 40px;
		svg {
			path {
				stroke: white;
			}
		}
	}

	.MuiListItemText-root span.MuiTypography-root {
		color: ${({ theme }) => theme.palette.background.app.light};
	}
`

export const logoStyle = css`
	width: 200px;
	max-width: 200px;
	height: auto;
	&.unitedAnesthesia {
		width: 174px;
		height: auto;
		${({ theme }) => theme.breakpoints.down('sm')} {
			width: 140px;
			max-width: 140px;
			margin-top: -5px;
		}
	}
	&.planet {
		width: 250px;
		max-width: 250px;
		height: auto;
	}
`

export const onboardingPercentageStyle = css`
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 18px;
	margin-top: 4px;
	margin-bottom: 4px;

	letter-spacing: 0.3px;
	padding-left: 10px;
	color: ${({ theme }) => theme.palette.status.warning.medium} !important;
`

export const wrapperStyle = css`
	border-radius: 20px;
	background: #fff;
	padding: 16px;
	margin-bottom: 16px;
`

export const wrapperSearchLayoutStyle = css`
	border-radius: 20px;
	margin-bottom: 16px;
`

export const titleProfileStyle = css`
	font-size: 20px;
	font-weight: 700;
	line-height: 26px;
	letter-spacing: 0.1px;
	color: ${({ theme }) => theme.colors.content.veryDark};

	border-radius: 20px;
	background: #fff;
	padding: 16px;
	margin-bottom: 16px;
`

export const TabsContainer = styled(Tabs)`
	color: ${({ theme }) => theme.colors.content.dark};
	.MuiTabs-indicator {
		background-color: ${({ theme }) => theme.colors.secondary.main};
		height: 4px;
	}

	.MuiTypography-root {
		${({ theme }) => theme.typography.h4};
		font-weight: 800;
	}

	.MuiTab-textColorInherit {
		opacity: inherit;
	}

	.MuiTabs-flexContainer {
		height: 100%;
		align-items: center;
	}

	.MuiTab-root.Mui-selected {
		color: ${({ theme }) => theme.colors.secondary.main};
		.MuiTypography-root {
			${({ theme }) => theme.typography.h4};
			font-weight: 800;
		}
	}
`

export const wrapperKeywordGlobalSearch = css`
	display: flex;
	align-items: center;
	justify-content: right;
	&.fullWidthWrapper {
		width: 100%;
	}
	&.fullWidthWrapper form {
		width: calc(100% - 100px);
	}
	&.normalWrapper {
		width: unset;
	}
	.form-global-search {
		display: flex;
		align-items: center;
	}
`
